module.exports = __webpack_public_path__ + "e026d18f9280c7acca20e86204ea2242.svg";